<template>
  <div>
    <div class="record_date">
      <el-row>
        <el-col :span="6" class="cards">
          <div class="box">
            <div class="box_num">
              <div class="box_color">总用户</div>
              <div class="text_color">
                <span>{{ dataInfo.userCount }}</span
                >人
              </div>
            </div>
          </div>
        </el-col>

        <!-- <el-col :span="6" class="cards">
          <div class="box">
            <div class="box_num">
              <div class="box_color">总提现</div>
              <div class="text_color">
                <span>{{ sumincome | numFilter }}</span
                >元
              </div>
            </div>
          </div>
        </el-col> -->
        <!-- <el-col :span="6" class="cards">
          <div class="box">
            <div class="box_num">
              <div class="box_color">总收入</div>
              <div class="text_color">
                <span>{{ sumincome | numFilter }}</span
                >元
              </div>
            </div>
          </div>
        </el-col> -->
      </el-row>
      <div>
        <el-select
          v-model="way"
          style="width:150px;margin-left: 10px;"
          @change="orderfenxi"
        >
          <el-option
            v-for="item in ways"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option> </el-select
        >&nbsp;&nbsp;&nbsp;
        <el-date-picker
          style="width: 160px;margin-left: 10px;"
          v-model="stockDate"
          align="right"
          type="datetime"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间"
          @change="animeOrder"
        >
        </el-date-picker>
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        style="margin-left: 10px;"
      >
        <el-tab-pane label="用户分析" name="first">
          <el-row>
            <el-col :span="6" class="cards">
              <div class="box">
                <div class="box_num">
                  <div class="box_color">注册人数</div>
                  <div class="text_color">
                    <span>{{ dataInfo.regisCount }}</span
                    >人
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6" class="cards">
              <div class="box">
                <div class="box_num">
                  <div class="box_color">活跃量</div>
                  <div class="text_color">
                    <span>{{ dataInfo.hyCount }}</span
                    >人
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getIndexData } from "../../api/userMG";
export default {
  data() {
    return {
      size: 5,
      page: 1,
      tableData: [],
      userjfData: [],
      fenxiaoData: [],
      totalnum: 0,
      status: 0,
      consultNumber: "",
      stallNumber: "",
      amorNumber: "",
      skillNumber: "",
      nowDayJieSuan: "",
      nowMonthJieSuan: "",
      activeName: "first",
      tableDataLoading: true,
      intervalId: 0,
      userStat: 0, //总用户统计
      sumincome: "",
      totalnum: 0,
      income: "",
      wxincome: "",
      zfbincome: "",
      yueicome: "",
      ordersum0: "",
      ordersum1: "",
      ordersum2: "",
      memberStat: 0,
      notmberStat: 0,
      appStat: 0,
      weixinStat: 0,
      wapStat: 0,
      phoneStat: 0,
      notphoneStat: 0, //未绑定手机号
      data: "",
      time: "",
      platform: "",
      type: "",
      balance: -1,
      way: 3,
      tk_status0: 12,
      tk_status1: 3,
      info: {
        stockDate: this.getNowTime() //日期
      },
      stockDate:this.getNowTime(),
      ways: [
        {
          value: 3,
          label: "按天查询"
        },
        {
          value: 2,
          label: "按月查询"
        },
        {
          value: 1,
          label: "按年查询"
        }
      ],
      mp: "",
      app: "",
      weixin: "",
      refundMoney: "",
      refundIncome: "",
      refundNum: "",
      pingMoney: "",
      dataInfo: {}
    };
  },
  filters: {
    numFilter(value) {
      let realVal = "";
      if (!isNaN(value) && value !== "") {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2);
      } else {
        realVal = "--";
      }
      return realVal;
    }
  },
  mounted() {
    var startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    var startTimestamp = startOfToday.getTime();
    // 获取今天的结束时间戳
    var endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 999);
    var endTimestamp = endOfToday.getTime();
    console.log("今天开始时间戳:", startTimestamp);
    console.log("今天结束时间戳:", endTimestamp);
    this.getIndexDataFn(startTimestamp, endTimestamp);
  },
  methods: {
    getIndexDataFn(startTime, endTime) {
      let startSt = (startTime / 1000).toFixed(0);
      let endT = (endTime / 1000).toFixed(0);
      getIndexData({
        startTime: Number(startSt),
        endTime: Number(endT)
      }).then(res => {
        console.log("getIndexDataFn===", res);
        if (res.code == 200) {
          this.dataInfo = res.data;
        }
      });
    },
    // 订单分析选择日期
    animeOrder(e) {
      let time = e;
      let startTimeStamps = new Date(time).setHours(0, 0, 0, 0);
      let endTimeStamps = new Date(time).setHours(23, 59, 59, 999)
      this.getIndexDataFn(startTimeStamps,endTimeStamps);
       
    },
    // 订单分析年月日
    orderfenxi(value) {
      let vanumber = value;

      if (vanumber === 3) {
        //按天查询
        var startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);
        var startTimestamp = startOfToday.getTime();

        // 获取今天的结束时间戳
        var endOfToday = new Date();
        endOfToday.setHours(23, 59, 59, 999);
        var endTimestamp = endOfToday.getTime();

        console.log("今天开始时间戳:", startTimestamp);
        console.log("今天结束时间戳:", endTimestamp);
        this.getIndexDataFn(startTimestamp, endTimestamp);
      }
      if (vanumber === 2) {
        let year = new Date().getFullYear();
        let month = new Date().getMonth();
        console.log("year===", year);
        console.log("month===", month);

        const startDate = new Date(year, month - 1, 1); // 当月的第一天
        const endDate = new Date(year, month, 0); // 当月的第零天，即上个月的最后一天
        const startTimestamp = startDate.getTime(); // 开始时间戳
        const endTimestamp = endDate.getTime(); // 结束时间戳
        console.log("今月开始时间戳:", startTimestamp);
        console.log("今月结束时间戳:", endTimestamp);
        this.getIndexDataFn(startTimestamp, endTimestamp); // 结束时间戳
      }
      if (vanumber === 1) {
        const startOfYear = new Date();
        startOfYear.setMonth(0); // 设置为1月
        startOfYear.setDate(1); // 设置为1日
        startOfYear.setHours(0); // 设置为0时
        startOfYear.setMinutes(0); // 设置为0分
        startOfYear.setSeconds(0); // 设置为0秒
        startOfYear.setMilliseconds(0); // 设置为0毫秒
        let startOfYearTime = startOfYear.getTime();
        const endOfYear = new Date();
        endOfYear.setMonth(11); // 设置为12月
        endOfYear.setDate(31); // 设置为31日
        endOfYear.setHours(23); // 设置为23时
        endOfYear.setMinutes(59); // 设置为59分
        endOfYear.setSeconds(59); // 设置为59秒
        endOfYear.setMilliseconds(999); // 设置为999毫秒
        let endOfYearTime = endOfYear.getTime();

        this.getIndexDataFn(startOfYearTime, endOfYearTime); // 结束时间戳
      }
    },
    // Tabs点击事件
    handleClick(tab, event) {
      if (tab._props.label == "用户分析") {
        this.info.stockDate = this.getNowTime();
      }
      if (tab._props.label == "订单分析") {
        this.info.stockDate = this.getNowTime();
      }
      if (tab._props.label == "自营订单分析") {
        this.moneySelect();
        this.orderSelect();
      }
    },
    //处理默认选中当前日期
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      return defaultDate;
      this.$set(this.info, "stockDate", defaultDate);
    },
    // 公众号关注用户
    consultData() {
      this.$http({
        url: this.$http.adornUrl2("/wx/getUserTotal"),
        method: "get",
        params: this.$http.adornParams({})
      }).then(({ data }) => {
        let returnData = data.data;
        this.consultNumber = returnData;
      });
    },
    //累计会员
    amorData() {
      this.$http({
        url: this.$http.adornUrl2("/user/findAllByRelationIdNotNull"),
        method: "get",
        params: this.$http.adornParams({})
      }).then(({ data }) => {
        let returnData = data.data.length;
        this.amorNumber = returnData;
      });
    },
    //总用户
    skillData() {
      this.$http({
        url: this.$http.adornUrl2("/user/getCountNumber"),
        method: "get",
        params: this.$http.adornParams({})
      }).then(({ data }) => {
        let returnData = data.data;
        this.skillNumber = returnData;
      });
    },
    // 用户分析
    userData(platform, type) {
      this.$http({
        url: this.$http.adornUrl2("/statistics/getUserTotal"),
        method: "get",
        params: this.$http.adornParams({
          time: this.info.stockDate,
          platform: platform,
          type: type
        })
      }).then(({ data }) => {
        let returnData = data.data;
        if (platform === "app" && type === -1) {
          this.appStat = returnData;
        }

        if (platform === "wap" && type === -1) {
          this.wapStat = returnData;
        }

        if (platform === "weixin" && type === -1) {
          this.weixinStat = returnData;
        }

        if (platform === "all" && type === -1) {
          this.userStat = returnData;
        }

        if (platform === "all" && type === 1) {
          this.memberStat = returnData;
        }

        if (platform === "all" && type === 0) {
          this.notmberStat = returnData;
        }
      });
    },
    // 手机号统计
    phoneData() {
      this.$http({
        url: this.$http.adornUrl2("/statistics/getCountNumberByTimeByPhone"),
        method: "get",
        params: this.$http.adornParams({
          time: this.info.stockDate
        })
      }).then(({ data }) => {
        let returnData = data.data;
        this.phoneStat = returnData;
      });
    },
    // 团长分析
    colonel() {
      this.tableDataLoading = true;
      this.$http({
        url: this.$http.adornUrl2("/statistics/getCountByTime"),
        method: "get",
        params: this.$http.adornParams({
          time: this.info.stockDate
        })
      }).then(({ data }) => {
        this.tableDataLoading = false;
        let returnData = data.data;
        this.tableData = returnData;
      });
    },
    // 用户积分分析
    userinteData() {
      this.tableDataLoading = true;
      this.$http({
        url: this.$http.adornUrl2("/statistics/totalJiFen"),
        method: "get",
        params: this.$http.adornParams({
          time: this.info.stockDate
        })
      }).then(({ data }) => {
        this.tableDataLoading = false;
        let returnData = data.data;
        this.userjfData = returnData;
      });
    },
    // 收入金额统计
    moneySelect() {
      let page = this.page - 1;
      this.tableDataLoading = true;
      this.$http({
        url: this.$http.adornUrl2("/orders/income"),
        method: "get",
        params: this.$http.adornParams({
          data: this.info.stockDate,
          way: this.way
        })
      }).then(({ data }) => {
        this.tableDataLoading = false;
        let returnData = data.data;
        this.sumincome = returnData.sum0;
        this.income = returnData.sum1;
        this.wxincome = returnData.pay1;
        this.zfbincome = returnData.pay2;
        this.yueicome = returnData.pay3;
        this.refundIncome = returnData.refundIncome;
        this.refundMoney = returnData.refundMoney;
        this.refundNum = returnData.refundNum;
        this.pingMoney = returnData.pingMoney;
      });
    },
    // 订单成交量统计
    orderSelect() {
      let page = this.page - 1;
      this.tableDataLoading = true;
      this.$http({
        url: this.$http.adornUrl2("/orders/statistical"),
        method: "get",
        params: this.$http.adornParams({
          data: this.info.stockDate
        })
      }).then(({ data }) => {
        this.tableDataLoading = false;
        let returnData = data.data;
        this.ordersum0 = returnData.sum0;
        this.ordersum1 = returnData.sum1;
        this.ordersum2 = returnData.sum2;
      });
    },
    // 用户分析统计
    usersSelect() {
      let page = this.page - 1;
      this.tableDataLoading = true;
      this.$http({
        url: this.$http.adornUrl2("/statistics/getUserPlatformByTime"),
        method: "get",
        params: this.$http.adornParams({
          time: this.info.stockDate
        })
      }).then(({ data }) => {
        this.tableDataLoading = false;
        let returnData = data.data;
        this.mp = returnData.mp;
        this.app = returnData.app;
        this.weixin = returnData.weixin;
      });
    }
  }
};
</script>

<style scoped>
.box {
  padding: 24px;
  border: 1px solid #eee;
  margin: 15px 10px;
}
.box_num {
  font-size: 14px;
  color: #66b1ff;
}
.box_num .box_color {
  color: #333;
  font-size: 14px;
  margin-bottom: 15px;
}
.box_num div span {
  font-size: 20px;
  margin-left: 5px;
}
.text_color {
  color: #4f9dec;
}
.text_color span {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue